import trim from "lodash/trim";
var LoadWebp = {
    isWebp: (function () {
        try {
            return (document
                .createElement("canvas")
                .toDataURL("image/webp")
                .indexOf("data:image/webp") === 0);
        }
        catch (err) {
            return false;
        }
    })(),
    setSrc: function (str) {
        var _url = this._urlFormat(str);
        str = !_url ? str : _url;
        var src = "";
        var arr = str.match(/\*(\d+)x(\d+)./);
        if (arr === null) {
            if (this.isWebp) {
                if (/@/.test(str)) {
                    var newStr = str.substring(0, str.lastIndexOf("."));
                    src = newStr + ".webp";
                }
                else {
                    src = str + "@.webp";
                }
            }
            else {
                src = str;
            }
        }
        else if (this.isWebp) {
            src = str.split("*")[0] + "@" + arr[1] + "w_" + arr[2] + "h.webp";
        }
        else {
            src = str.split("*")[0] + "@" + arr[1] + "w_" + arr[2] + "h";
        }
        return src;
    },
    _urlFormat: function (url) {
        var reg1 = /\/\d+?_\d+?\/bfs/;
        var newUrl = url.replace(reg1, "/bfs");
        if (!reg1.test(url))
            return false;
        return newUrl + "_" + RegExp.$1 + "x" + RegExp.$2 + RegExp.$3;
    },
};
export function cutImage(url, imgWidth, imgHeight, isNotWebp) {
    if (typeof url !== "string") {
        return url;
    }
    url = trim(url);
    var reg = /^http:\/\/|https:\/\//;
    if (reg.test(url)) {
        url = url.replace(reg, "//");
    }
    var bfs = url.indexOf("/bfs/") !== -1;
    var gif = url.indexOf(".gif") !== -1;
    var webp = url.indexOf(".webp") !== -1;
    if (!bfs || gif || webp) {
        return url;
    }
    var urls = url.split("?");
    var sizes = {};
    var matches = [];
    var rules = {
        cdn: /^\/\/i[0-2]\.hdslb\.com\//,
        bfs: /^\/\/i\d\.hdslb\.com\/bfs\//,
        group1: /^\/\/i\d\.hdslb\.com\/group1\//,
        other: /(^\/\/i\d\.hdslb\.com)(\/.+)/,
    };
    var feature = {
        bfs: /_\d+x\d+\./,
        other: /\/\d+_\d+\//,
    };
    if (typeof imgHeight !== "boolean") {
        imgHeight = imgHeight || imgWidth;
        sizes = {
            midfix: "/" + imgWidth + "_" + imgHeight,
            suffix: "*" + imgWidth + "x" + imgHeight,
        };
    }
    else {
        sizes = {
            midfix: "@" + imgWidth + "w",
            suffix: "@" + imgWidth + "w",
        };
    }
    if (!rules.cdn.test(urls[0])) {
        return url;
    }
    if (feature.bfs.test(urls[0]) || feature.other.test(urls[0])) {
        return url;
    }
    if (rules.bfs.test(urls[0]) || rules.group1.test(urls[0])) {
        if (typeof imgWidth !== "undefined") {
            urls[0] += sizes.suffix + urls[0].slice(urls[0].lastIndexOf("."));
        }
        url = urls.join("?");
    }
    else {
        matches = rules.other.exec(urls[0]);
        if (matches) {
            urls[0] = matches[1] + sizes.midfix + matches[2];
            url = urls.join("?");
        }
    }
    var resultUrl;
    if (isNotWebp) {
        resultUrl = url;
    }
    else {
        resultUrl = LoadWebp.setSrc(url);
    }
    return resultUrl;
}
//# sourceMappingURL=imgWebp.js.map